export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_PARAKEY",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_PARAKEY",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_PARAKEY",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_PARAKEY",
  DESTROY_FORM: "DESTROY_FORM_PARAKEY",
  SET_FORM_ERROR: "SET_FORM_ERROR_PARAKEY",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_PARAKEY",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_PARAKEY",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_PARAKEY",
  RESET_STATE: "RESET_STATE_PARAKEY",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_PARAKEY",
  REMOVE_OBJECT: "REMOVE_OBJECT_PARAKEY",
  CLEAR_FETCHED: "CLEAR_FETCHED_PARAKEY",

  LIST_URL: "/keyhandling/parakeycredential/list/",
  POST_URL: "/keyhandling/parakeycredential/",
  PATCH_URL: "/keyhandling/parakeycredential/",
  GET_URL: "/keyhandling/parakeycredential/",

  STORE_NAME: "parakeyIntegration",
};
